import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createTaskAsync, deleteTaskAsync, getAllTaskAssignedToUserAsync, getAllTasksAsync, getTaskByIdAsync, getTasksByEventIdGroupedByStatusAsync, getTasksGroupedByStatusAsync, updateTaskAsync, getAllActivityTasksAsync } from './taskThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const taskSlice = createSlice({
    name: 'task',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createTaskAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createTaskAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.task = action.payload;
        })
            .addCase(createTaskAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateTaskAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateTaskAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.task = action.payload;
        })
            .addCase(updateTaskAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllTasksAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllTasksAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.tasks = action.payload;
        })
            .addCase(getAllTasksAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllTaskAssignedToUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllTaskAssignedToUserAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.tasksAssignedToUser = action.payload;
        })
            .addCase(getAllTaskAssignedToUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getTasksGroupedByStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getTasksGroupedByStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.tasksByStatus = action.payload;
        })
            .addCase(getTasksGroupedByStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getTaskByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getTaskByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.task = action.payload;
        })
            .addCase(getTaskByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteTaskAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteTaskAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            // Note: For delete operations, we don't need to update state with returned data
            // The UI will refresh the task list separately
        })
            .addCase(deleteTaskAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getTasksByEventIdGroupedByStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getTasksByEventIdGroupedByStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.tasksByEventIdGroupedByStatus = action.payload;
        })
            .addCase(getTasksByEventIdGroupedByStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllActivityTasksAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllActivityTasksAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.activityTasks = action.payload;
        })
            .addCase(getAllActivityTasksAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default taskSlice.reducer;
